import gql from 'graphql-tag';

import printProductSizeBaseDetails from './printProductSizeBaseDetails';

const printProductBaseDetails = gql`
  fragment printProductBaseDetails on PrintProduct {
    id
    name
    card {
      id
    }
    preview_asset_image {
      id
      url
      width
      height
    }
    sizes(slice: { limit: 999 }) {
      total
      records {
        ...printProductSizeBaseDetails
      }
    }
  }
  ${printProductSizeBaseDetails}
`;

export default printProductBaseDetails;
